/**
 * Enhanced collection product card: variant pills update image, price, compare row, and cart variant id.
 * Uses event delegation so cards work after facet AJAX refresh.
 */
(function () {
  function parseBool(el, attr, fallback) {
    var v = el.getAttribute(attr);
    if (v === null || v === '') return fallback;
    return v === 'true' || v === '1';
  }

  function announceVariantChange(root, btn) {
    var live = root.querySelector('[data-npc-variant-live]');
    if (!live || !btn) return;
    var variantName = btn.getAttribute('aria-label') || btn.getAttribute('title') || '';
    var price = btn.getAttribute('data-price-money') || '';
    live.textContent = variantName && price ? variantName + ', ' + price : price || variantName;
  }

  function updateCard(root, btn) {
    if (!root || !btn) return;

    var img = root.querySelector('.npc__img');
    var priceEl = root.querySelector('[data-npc-current-price]');
    var saleWrap = root.querySelector('[data-npc-sale-wrap]');
    var compareRow = root.querySelector('[data-npc-compare-row]');
    var compareAmount = root.querySelector('[data-npc-compare-amount]');
    var variantInput = root.querySelector('.npc-variant-id');
    var addBtn = root.querySelector('.npc__add-btn');
    var saleBadge = root.querySelector('[data-npc-sale-badge]');

    var imageUrl = btn.getAttribute('data-image-url') || '';
    var defaultSrc = img && img.getAttribute('data-default-src');
    if (img) {
      img.src = imageUrl || defaultSrc || img.src;
    }

    if (priceEl) {
      priceEl.textContent = btn.getAttribute('data-price-money') || '';
    }

    var compareMoney = btn.getAttribute('data-compare-money') || '';
    var showCompare =
      parseBool(root, 'data-show-retail', true) && compareMoney.length > 0;

    if (compareRow) {
      compareRow.hidden = !showCompare;
    }
    if (compareAmount) {
      compareAmount.textContent = compareMoney;
    }
    if (saleWrap) {
      saleWrap.classList.toggle('npc__price-row--on-sale', showCompare);
    }

    if (saleBadge) {
      var saleLabel = btn.getAttribute('data-sale-label') || '';
      if (saleLabel.length > 0) {
        saleBadge.textContent = saleLabel;
        saleBadge.removeAttribute('hidden');
        saleBadge.setAttribute('aria-hidden', 'false');
      } else {
        saleBadge.textContent = '';
        saleBadge.setAttribute('hidden', '');
        saleBadge.setAttribute('aria-hidden', 'true');
      }
    }

    var available = parseBool(btn, 'data-available', true);
    if (variantInput) {
      variantInput.value = btn.getAttribute('data-variant-id') || '';
    }
    if (addBtn) {
      addBtn.disabled = !available;
    }

    root.querySelectorAll('.npc__variant-pill').forEach(function (p) {
      p.classList.toggle('npc__variant-pill--selected', p === btn);
      p.setAttribute('aria-pressed', p === btn ? 'true' : 'false');
    });

    announceVariantChange(root, btn);
  }

  function closeAllRetailTips(restoreFocusTo) {
    document.querySelectorAll('[data-new-product-card].npc--retail-tip-open').forEach(function (root) {
      root.classList.remove('npc--retail-tip-open');
      var b = root.querySelector('.npc__info-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
      var t = root.querySelector('.npc__retail-tooltip');
      if (t) t.setAttribute('aria-hidden', 'true');
    });
    if (restoreFocusTo && typeof restoreFocusTo.focus === 'function') {
      restoreFocusTo.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var infoBtn = e.target.closest('.npc__info-btn');
    if (infoBtn) {
      e.preventDefault();
      e.stopPropagation();
      var root = infoBtn.closest('[data-new-product-card]');
      if (!root) return;
      var willOpen = !root.classList.contains('npc--retail-tip-open');
      closeAllRetailTips();
      if (willOpen) {
        root.classList.add('npc--retail-tip-open');
        infoBtn.setAttribute('aria-expanded', 'true');
        var tip = root.querySelector('.npc__retail-tooltip');
        if (tip) tip.setAttribute('aria-hidden', 'false');
      }
      return;
    }

    if (e.target.closest('.npc__retail-tooltip')) {
      return;
    }

    closeAllRetailTips();

    var btn = e.target.closest('.npc__variant-pill');
    if (!btn) return;
    var cardRoot = btn.closest('[data-new-product-card]');
    if (!cardRoot) return;
    e.preventDefault();
    updateCard(cardRoot, btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var active = document.activeElement;
    if (active && active.classList && active.classList.contains('npc__info-btn')) {
      closeAllRetailTips(active);
      return;
    }
    closeAllRetailTips();
  });
})();
